import {useMemo} from "react";

import {useGetRecommendedOffersQuery} from "../../offer/api/get_recommended_offers";
import {IRecommendedOffer} from "../../offer/types/IRecommendedOffer";
import {useGetRecommendedPropertiesQuery} from "../../property/api/get_recommended_properties";
import {IRecommendedProperty} from "../../property/types/IRecommendedProperty";

interface IUseRecommendationsBaseProps {
    offerId?: number | null;
    excludedOfferIds: number[];
    skip?: boolean;
}

export interface IUseRecommendationsPropertyProps extends IUseRecommendationsBaseProps {
    propertyId: number;
    filters?: Record<string, string | number>;
}

export interface IUseRecommendationsOfferProps extends IUseRecommendationsBaseProps {
    propertyId?: never;
    numberOfRooms?: number[] | null;
}

interface IResult<T extends {} | null> {
    results: T[];
    isLoading: boolean;
    error: unknown;
    isSuccess: boolean;
}

type IPropertyResult = IResult<IRecommendedProperty>;
type IOfferResult = IResult<IRecommendedOffer>;
type IEmptyResult = Omit<IResult<null>, "results"> & {results: IRecommendedProperty[] | IRecommendedOffer[]};

export function useRecommendations(params: IUseRecommendationsPropertyProps): IPropertyResult;
export function useRecommendations(params: IUseRecommendationsOfferProps): IOfferResult;
export function useRecommendations(params: IUseRecommendationsBaseProps): IEmptyResult;
export function useRecommendations(params: IUseRecommendationsPropertyProps | IUseRecommendationsOfferProps): IPropertyResult | IOfferResult | IEmptyResult {
    const {offerId, propertyId, excludedOfferIds, skip} = params;
    const filters: Record<string, string | number> | undefined = "filters" in params ? params.filters : undefined;
    const numberOfRooms = "numberOfRooms" in params ? params.numberOfRooms : null;

    const shouldFetchProperties = !!propertyId;
    const shouldFetchOffers = !!offerId && !propertyId;

    const propertyParams = useMemo(() => {
        if (!shouldFetchProperties || !propertyId) {
            return null;
        }

        if (filters?.max_price && offerId) {
            return {
                propertyId: propertyId,
                excludedOfferIds: [],
                filters: {...filters, offer: offerId}
            };
        }

        return {
            propertyId: propertyId,
            excludedOfferIds,
            filters
        };
    }, [shouldFetchProperties, propertyId, excludedOfferIds.join(","), filters, offerId]);

    const propertyQuery = useGetRecommendedPropertiesQuery(propertyParams!, {
        skip: !shouldFetchProperties || skip
    });

    const excludedOfferIdsWithoutOfferId = useMemo(() => {
        return offerId ? excludedOfferIds.filter((id) => id !== offerId) : excludedOfferIds;
    }, [excludedOfferIds, offerId]);

    const offerQuery = useGetRecommendedOffersQuery(
        {
            offerId: offerId!,
            numberOfRooms,
            excludedOfferIds: excludedOfferIdsWithoutOfferId
        },
        {
            skip: !shouldFetchOffers || skip
        }
    );

    return useMemo(() => {
        if (shouldFetchProperties) {
            return {
                results: propertyQuery.data?.results || [],
                isLoading: propertyQuery.isLoading,
                error: propertyQuery.error,
                isSuccess: propertyQuery.isSuccess
            };
        }

        if (shouldFetchOffers) {
            return {
                results: offerQuery.data?.results || [],
                isLoading: offerQuery.isLoading,
                error: offerQuery.error,
                isSuccess: offerQuery.isSuccess
            };
        }

        return {
            results: [],
            isLoading: false,
            error: null,
            isSuccess: true
        };
    }, [shouldFetchProperties, shouldFetchOffers, propertyQuery, offerQuery]);
}
import {useMemo} from "react";

import {useGetRecommendedOffersQuery} from "../../offer/api/get_recommended_offers";
import {IRecommendedOffer} from "../../offer/types/IRecommendedOffer";
import {useGetRecommendedPropertiesQuery} from "../../property/api/get_recommended_properties";
import {IRecommendedProperty} from "../../property/types/IRecommendedProperty";

interface IUseRecommendationsBaseProps {
    offerId?: number | null;
    excludedOfferIds: number[];
    skip?: boolean;
}

export interface IUseRecommendationsPropertyProps extends IUseRecommendationsBaseProps {
    propertyId: number;
    filters?: Record<string, string | number>;
}

export interface IUseRecommendationsOfferProps extends IUseRecommendationsBaseProps {
    propertyId?: never;
    numberOfRooms?: number[] | null;
}

interface IResult<T extends {} | null> {
    results: T[];
    isLoading: boolean;
    error: unknown;
    isSuccess: boolean;
}

type IPropertyResult = IResult<IRecommendedProperty>;
type IOfferResult = IResult<IRecommendedOffer>;
type IEmptyResult = Omit<IResult<null>, "results"> & {results: IRecommendedProperty[] | IRecommendedOffer[]};

export function useRecommendations(params: IUseRecommendationsPropertyProps): IPropertyResult;
export function useRecommendations(params: IUseRecommendationsOfferProps): IOfferResult;
export function useRecommendations(params: IUseRecommendationsBaseProps): IEmptyResult;
export function useRecommendations(params: IUseRecommendationsPropertyProps | IUseRecommendationsOfferProps): IPropertyResult | IOfferResult | IEmptyResult {
    const {offerId, propertyId, excludedOfferIds, skip} = params;
    const filters: Record<string, string | number> | undefined = "filters" in params ? params.filters : undefined;
    const numberOfRooms = "numberOfRooms" in params ? params.numberOfRooms : null;

    const shouldFetchProperties = !!propertyId;
    const shouldFetchOffers = !!offerId && !propertyId;

    const propertyParams = useMemo(() => {
        if (!shouldFetchProperties || !propertyId) {
            return null;
        }

        if (filters?.max_price && offerId) {
            return {
                propertyId: propertyId,
                excludedOfferIds: [],
                filters: {...filters, offer: offerId}
            };
        }

        return {
            propertyId: propertyId,
            excludedOfferIds,
            filters
        };
    }, [shouldFetchProperties, propertyId, excludedOfferIds.join(","), filters, offerId]);

    const propertyQuery = useGetRecommendedPropertiesQuery(propertyParams!, {
        skip: !shouldFetchProperties || skip
    });

    const excludedOfferIdsWithoutOfferId = useMemo(() => {
        return offerId ? excludedOfferIds.filter((id) => id !== offerId) : excludedOfferIds;
    }, [excludedOfferIds, offerId]);

    const offerQuery = useGetRecommendedOffersQuery(
        {
            offerId: offerId!,
            numberOfRooms,
            excludedOfferIds: excludedOfferIdsWithoutOfferId
        },
        {
            skip: !shouldFetchOffers || skip
        }
    );

    return useMemo(() => {
        if (shouldFetchProperties) {
            return {
                results: propertyQuery.data?.results || [],
                isLoading: propertyQuery.isLoading,
                error: propertyQuery.error,
                isSuccess: propertyQuery.isSuccess
            };
        }

        if (shouldFetchOffers) {
            return {
                results: offerQuery.data?.results || [],
                isLoading: offerQuery.isLoading,
                error: offerQuery.error,
                isSuccess: offerQuery.isSuccess
            };
        }

        return {
            results: [],
            isLoading: false,
            error: null,
            isSuccess: true
        };
    }, [shouldFetchProperties, shouldFetchOffers, propertyQuery, offerQuery]);
}
